import { diarySharingConstants } from '../_constants/diarySharing.constants';

const initialState = {
    bulkShare: true,
    staff: [],
    loading: false,
    error: null,
    myVisibility: [],
};

export function diarySharing(state = initialState, action) {
    switch (action.type) {
        case diarySharingConstants.FETCH_REQUEST:
            return { ...state, loading: true, error: null };

        case diarySharingConstants.FETCH_SUCCESS:
            return {
                ...state,
                loading: false,
                bulkShare: action.bulkShare,
                staff: action.staff,
            };

        case diarySharingConstants.FETCH_FAILURE:
            return { ...state, loading: false, error: action.error };

        case diarySharingConstants.UPDATE_BULK:
            return {
                ...state,
                bulkShare: action.bulkShare,
                // Only reset employed staff when turning bulk off.
                // Self-employed keep their own settings.
                staff: action.bulkShare
                    ? state.staff
                    : state.staff.map((s) =>
                        s.employmentTypeId !== 2
                            ? { ...s, diaryVisibility: 'everyone', diaryVisibleTo: [] }
                            : s,
                    ),
            };

        case diarySharingConstants.UPDATE_STAFF:
            return {
                ...state,
                staff: state.staff.map((s) =>
                    s.hairdresserId === action.staffId
                        ? {
                            ...s,
                            diaryVisibility: action.diaryVisibility,
                            diaryVisibleTo: action.diaryVisibleTo || [],
                        }
                        : s,
                ),
            };

        case diarySharingConstants.VISIBILITY_LOAD:
            return { ...state, myVisibility: action.canSee };

        default:
            return state;
    }
}
